/**
 * Traduz códigos técnicos de status para labels em português amigáveis.
 * Fonte única — usar em qualquer tabela/listagem/badge de status.
 */

const RESERVATION_STATUS_MAP = {
  pending: 'Aguardando pagamento',
  confirmed: 'Confirmada',
  paid: 'Paga',
  pago_parcial: 'Paga parcialmente',
  completed: 'Concluída',
  cancelled: 'Cancelada',
  cancelled_by_agency: 'Cancelada pela agência',
  cancelled_by_customer: 'Cancelada pelo cliente',
  cancelled_transferred_to_credit: 'Transferido',
  transferred_to_credit: 'Transferido',
  awaiting_contract_acceptance: 'Aguardando aceite do contrato',
  cancellation_requested: 'Cancelamento solicitado — aguardando análise',
  awaiting_agency_review: 'Aguardando análise da agência',
  estornado: 'Estornada',
  trocado: 'Trocada',
};

const PAYMENT_STATUS_MAP = {
  RECEIVED: 'Recebido',
  CONFIRMED: 'Confirmado',
  PAID: 'Pago',
  APPROVED: 'Aprovado',
  PENDING: 'Aguardando',
  PROCESSING: 'Em processamento',
  OVERDUE: 'Vencido',
  REFUNDED: 'Estornado',
  DECLINED: 'Recusado',
  CANCELLED: 'Cancelado',
  received: 'Recebido',
  confirmed: 'Confirmado',
  paid: 'Pago',
  pending: 'Aguardando',
  refunded: 'Estornado',
};

const COMMISSION_STATUS_MAP = {
  paid: 'Comissão paga',
  available: 'Comissão liberada',
  pending: 'Aguardando viagem',
  cancelled_agency_refunded: 'Viagem cancelada — cliente reembolsado',
  cancelled_customer: 'Cancelado — cliente desistiu',
  postponed: 'Viagem adiada',
};

export const translateReservationStatus = (status) => {
  if (!status) return '-';
  return RESERVATION_STATUS_MAP[status] || status;
};

export const translatePaymentStatus = (status) => {
  if (!status) return '-';
  return PAYMENT_STATUS_MAP[status] || status;
};

export const translateCommissionStatus = (status) => {
  if (!status) return '-';
  return COMMISSION_STATUS_MAP[status] || status;
};

/** Utilitário genérico: aceita qualquer código e devolve versão pt-BR se conhecida. */
export const translateStatus = (status) => {
  return (
    RESERVATION_STATUS_MAP[status] ||
    PAYMENT_STATUS_MAP[status] ||
    COMMISSION_STATUS_MAP[status] ||
    status ||
    '-'
  );
};
